export class Emitter {
    constructor() {
        this.subs = new Set();
    }
    subscribe(sub) {
        this.subs.add(sub);
        return () => this.subs.delete(sub);
    }
    emit(value) {
        this.subs.forEach(sub => sub(value));
    }
}
